// extracted by mini-css-extract-plugin
export default {"authorQuotes__header":"_AuthorQuotes_authorQuotes__header__mIah+","quotes":"_AuthorQuotes_quotes__I5lps"};